import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.less']
})
export class HeaderComponent implements OnInit {

  langMenuOpen:boolean = false;
  userMenuOpen:boolean = false;

  languages = [
    {
      name: "Slovenina",
      code: "sl"
    },

    {
      name: "English",
      code: "en"
    }
  ];

  constructor(public translateService: TranslateService) 
  { 
    translateService.addLangs(['sl', 'en']);
    translateService.setDefaultLang('en');
  }

  ngOnInit(): void {
  }

  changeLanguage(lang){
    
  }

  openCloseLangMenu(){
    if(this.langMenuOpen){
      this.langMenuOpen = false;
    }
    else
    {
      this.langMenuOpen = true;
    }
  }
}